import React, { useState, useRef } from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { navigate } from 'gatsby'

import { ArrowLeft, ArrowRight } from "../../Arrow";

export const ContentSlider = ({ item }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [translateX, setTranslateX] = useState(0);
    const sliderRef = useRef(null);

    const totalSlides = item.contentBlogPicker.length;

    const nextSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
    };

    const prevSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + totalSlides) % totalSlides);
    };

    const handleMouseDown = (e) => {
      setIsDragging(true);
      setStartX(e.clientX);
    };

    const handleMouseMove = (e) => {
      if (!isDragging) return;
      const currentX = e.clientX;
      const diffX = currentX - startX;
      setTranslateX(diffX);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
      if (translateX > 50) {
        prevSlide();
      } else if (translateX < -50) {
        nextSlide();
      }
      setTranslateX(0);
    };

    const handleTouchStart = (e) => {
      setIsDragging(true);
      setStartX(e.touches[0].clientX);
    };

    const handleTouchMove = (e) => {
      if (!isDragging) return;
      const currentX = e.touches[0].clientX;
      const diffX = currentX - startX;
      setTranslateX(diffX);
    };

    const handleTouchEnd = () => {
      setIsDragging(false);
      if (translateX > 50) {
        prevSlide();
      } else if (translateX < -50) {
        nextSlide();
      }
      setTranslateX(0);
    };

    return (
        <div
            className="content-blog-picker-slider"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            ref={sliderRef}
        >
            <button onClick={prevSlide} className="prev-slide"><ArrowLeft/></button>
            <div className="slides-container" style={{ transform: `translateX(${translateX}px)` }}>
              {item.contentBlogPicker.map((subitem, index) => {
                const formattedDate = new Date(subitem.publishDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                });
                return (
                  <div key={index} className={`slide ${index === currentIndex ? "active" : "inactive"}`}>
                    <div className="relative content mb-10">
                      <div className="absolute top-0 left-0 w-full flex justify-between head">
                        {/* <div>By {subitem.author}</div> */}
                        <div>{subitem.parentCategory.categoryName}</div>
                        {subitem.includeDateDisplayInTheContentBlogPicker && <div>{formattedDate}</div>}
                      </div>
                      <div className="grid col-5-3 col-1-md">
                        <div className="relative inner-content">
                          <h4 className="cursor-pointer" onClick={()=>navigate(`/${subitem.parentCategory.slugId}/${subitem.blogPostUrlSlug}`)}>{subitem.title}</h4>
                          {documentToReactComponents(JSON.parse(subitem.excerpt.raw))}
                        </div>
                        <div
                          className="image cursor-pointer flex justify-center align-center"
                          style={{
                            backgroundColor: subitem.thumbnailColor || '#fff'
                          }}
                          onClick={()=>navigate(`/${subitem.parentCategory.slugId}/${subitem.blogPostUrlSlug}`)}
                        >
                          <img className='mb-0' src={subitem.thumbnailImage.gatsbyImageData.images.fallback.src} alt={subitem.title || 'Blog Picker Media Item'} style={{  height: '100%' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <button onClick={nextSlide} className="next-slide"><ArrowRight/></button>
        </div>
    )
}